import React, { useState } from 'react'
import Button, { buttonHierarchy, buttonShape } from '../../Button'
import { HeroIcons } from '../../../lib/utils/heroIcons'
import { formatCurrency } from '../../../lib/utils/formatNumber'
import { useTranslation } from 'next-i18next'
import useCurrency from '../../../hooks/useCurrency'
import useLocale from '../../../hooks/useLocale'

interface FractionsCardProps {
  currentFractionAmount: number
  totalPortfolioValue: number
}

export default function FractionsCard({
  currentFractionAmount,
  totalPortfolioValue,
}: FractionsCardProps) {
  const { t } = useTranslation('dashboard')

  const [toggleDataDisplay, setToggleDataDisplay] = useState<boolean>(false)
  const { currency } = useCurrency()
  const { locale } = useLocale()

  const handleToggleDataDisplay = () => {
    setToggleDataDisplay(!toggleDataDisplay)
  }

  const displayedData = toggleDataDisplay ? (
    <div className="text-4xl font-bold">
      {formatCurrency(totalPortfolioValue, 2, 2, currency, locale)}
    </div>
  ) : (
    <div className="flex items-baseline text-4xl font-bold">
      {currentFractionAmount}
      <div className="ml-1 text-sm font-normal">
        {t('statsCards.fractionCard.total', { count: currentFractionAmount })}
      </div>
    </div>
  )

  return (
    <div>
      <div className="relative overflow-hidden rounded-md bg-white">
        <div className="mb-3 flex items-center space-x-4 px-3 pt-3">
          <div className="w-1/6">
            <div className="rounded-md bg-primary p-3">
              <HeroIcons.QueueListIcon
                className="h- w-auto text-white"
                aria-hidden="true"
              />
            </div>
          </div>
          <div className="w-5/6">
            <div className="flex">
              <div className="flex-grow">
                <div className="text-sm font-medium text-neutralBlack/80">
                  {t('statsCards.fractionCard.title')}
                </div>
                <div className="text-2xl font-semibold text-neutralBlack">
                  {displayedData}
                </div>
              </div>
              <div>
                <Button
                  hierarchy={buttonHierarchy.custom}
                  shape={buttonShape.pill}
                  className="ml-auto text-neutralBlack/50 hover:text-neutralBlack"
                  onClick={handleToggleDataDisplay}
                >
                  <HeroIcons.ArrowPathRoundedSquareIcon className="h-5 w-auto" />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
